import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EditIcon from 'transfix-icons/build/EditIcon'
import { Card } from 'transfix-ui/components/Card'
import { IconButton } from 'transfix-ui/components/IconButton'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Table } from 'transfix-ui/components/Table'
import { getCapacity, openCarrierCapacityDialog } from 'apps/carrier/utils/actions/capacity'
import { IStore } from 'apps/carrier/utils/reducers'
import { ICarrierCapacity } from 'apps/marketplace/store/contractLanes/types'
import { CapacityDialog } from './CapacityDialog'
import { CapacityTableEntries } from './CapacityTableEntries'
import { CapacityTableHeader } from './CapacityTableHeader'

interface IState {
  id?: string
  offerLimits: ICarrierCapacity[]
  loading: boolean
  error?: string
}

export const Capacity = () => {
  const dispatch = useDispatch()
  const { error, id, loading, offerLimits } = useSelector<IStore, IState>(
    ({ carrier, carrierCapacity }) => ({
      id: carrier.carrierDetails?.id,
      offerLimits: carrierCapacity.capacities,
      loading: carrierCapacity.loading,
      error: carrierCapacity.error,
    })
  )
  useEffect(() => {
    if (id) dispatch(getCapacity(id))
  }, [id])

  const showCapacityDialogHandler = () => dispatch(openCarrierCapacityDialog())

  const empty = !loading && !error && !offerLimits.length
  const ready = !loading && !error && offerLimits.length > 0
  return (
    <Card>
      <div className='row pv4'>
        <h3 className='fl mb0 mt2'>Capacity</h3>
        <div className='fr'>
          <IconButton
            Icon={EditIcon}
            color='tertiary'
            onClick={showCapacityDialogHandler}
            data-test='edit-capacity'
            label='Edit Capacity'
            size='large'
          />
        </div>
      </div>
      {loading && <Spinner position='relative' />}
      {error && <InlineMessage message={error} type={INLINE_MESSAGE_VARIANTS.ALERT} />}
      {empty && <p className='tc'>This carrier’s typical capacity hasn’t been added yet.</p>}
      {ready && (
        <Table>
          <CapacityTableHeader />
          <CapacityTableEntries offerLimits={offerLimits} />
        </Table>
      )}
      <CapacityDialog />
    </Card>
  )
}
